<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="pays"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cle"
          :paginator="true"
          :rows="10"
          sort-field="pays"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} pays"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="valeur"
            header="Clé Pays"
            :sortable="true"
        ></Column>
        <Column field="texte" header="Pays" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['pays', 'isRechercheDataLoading'],
  emits: ['removePaysFromList'],
  components: {
    DialogConfirmation
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      paysToDelete: null,
    }
  },
  methods: {
    confirmerSuppression(data) {
      this.paysToDelete = data
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer le pays?",
        accept: this.supprimer,
        reject: () => {},
      })
    },
    supprimer() {
      let paysTableValeur = {};
      paysTableValeur.cle = this.paysToDelete.valeur;
      paysTableValeur.code = this.paysToDelete.texte;
      this.$store.dispatch('pilotage/supprimerTableValeurAction', {
          tableValeur: paysTableValeur
      }).then((res) => {
        if(res.data.length > 0){
          this.$root.$refs.messagesComp.messagesList = res.data
        }else{
          this.$toast.add({
            severity:'success',
            summary: 'Suppression Pays',
            detail:"La suppression a été effectuée",
            life: 6000
          });
          this.$emit("removePaysFromList", this.paysToDelete);
        }
      });
    },
    sauvegarder(data) {
      let tableValeur = {};
      let libelle = {};
      libelle.valeur = data.valeur;
      libelle.texte = data.texte;
      tableValeur.libelleVO = libelle;
      this.$store.dispatch('pilotage/modifierTableValeurAction', {tableValeur: tableValeur}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Modification Pays',
          detail:'La modification a été effectuée',
          life: 6000
        });
      });
    },
  }
}
</script>
